<template>
  <div class="teacher-list-placeholder">
    <BaseImg
      src="/front-img/public/tutor-list-placeholder.png"
      alt="top-banner"
      :sizes="{lg: [200, 180], xs: [112, 100]}"
      :lazy="true"
      class="mx-auto"
    />
    <p class="teacher-list-placeholder__text">
      {{ $t('placeholders.tutor_list_empty') }}
    </p>
    <BaseButton
      shadow
      size="md-lg"
      class="w-[160px] lg:w-[185px] mx-auto mt-8"
      :label="$t('actions.home_page')"
      tag="a"
      :href="$routes.home.path"
    />
  </div>
</template>
<script>
export default {
  name: 'TeacherListPlaceholder'
}
</script>
<style scoped lang="scss">
.teacher-list-placeholder {
  &__text {
    @apply mt-8 lg:text__headline-4-md--regular text__caption-xs--regular text-center;
  }
}
</style>
